import { render, staticRenderFns } from "./AddProductionModal.vue?vue&type=template&id=612bd47c&scoped=true&"
import script from "./AddProductionModal.vue?vue&type=script&lang=js&"
export * from "./AddProductionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddProductionModal.vue?vue&type=style&index=0&id=612bd47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612bd47c",
  null
  
)

export default component.exports